import React from 'react';
import { Page } from '../Page';
import { PullQuote } from '../PullQuote';
export function PagePlateaus() {
  return <Page pageNumber={38} variant="light" data-id="element-1118">
      <div className="flex h-full gap-12" data-id="element-1119">
        {/* Left 1/3 Column */}
        <div className="w-1/3 flex flex-col pt-32" data-id="element-1120">
          <PullQuote text="A plateau is not a failure. It is a signal to review your habits." variant="light" data-id="element-1121" />

          <div className="mt-auto border-t border-[#D8D8D0] pt-6" data-id="element-1122">
            <h3 className="font-bold text-[#1F1F1F] text-xs mb-2" data-id="element-1123">Remember</h3>
            <p className="text-[11px] text-[#7A7A70] leading-[1.6]" data-id="element-1124">
              Refer back to the "Managing Your Dose" page. A plateau is one of
              the few times increasing your dose might be the right next step,
              but only if your habits are dialed in.
            </p>
          </div>
        </div>

        {/* Right 2/3 Column */}
        <div className="w-2/3 flex flex-col" data-id="element-1125">
          <div className="mb-8 pt-4" data-id="element-1126">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1127">
              Challenges
            </p>
            <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1128">
              Navigating <span className="text-tealslate" data-id="element-1129">Plateaus</span>
            </h1>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-1130" />
          </div>

          <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-8" data-id="element-1131">
            A plateau is not a failure. It is a normal, expected part of the
            weight loss process. Your body is designed to fight weight loss to
            protect you from starvation. When you lose weight, your metabolism
            slows down to match your new, smaller body size.
          </p>

          <div className="border-l-4 border-tealslate pl-5 py-4 bg-[#EAEAE4] border-y border-r border-[#D8D8D0] mb-8" data-id="element-1132">
            <p className="text-sm font-serif text-[#1F1F1F] leading-[1.6]" data-id="element-1133">
              A true plateau is 4 weeks with no change in weight AND no change
              in measurements.
            </p>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-6 mb-8" data-id="element-1134">
            <h3 className="font-serif text-lg text-[#1F1F1F] mb-4" data-id="element-1135">
              Before assuming a true plateau, check:
            </h3>
            <ul className="space-y-3 text-xs text-[#7A7A70]" data-id="element-1136">
              <li className="flex items-center gap-3" data-id="element-1137">
                <div className="w-1.5 h-1.5 rounded-full bg-tealslate shrink-0" data-id="element-1138" />
                Are you sleeping enough?
              </li>
              <li className="flex items-center gap-3" data-id="element-1139">
                <div className="w-1.5 h-1.5 rounded-full bg-tealslate shrink-0" data-id="element-1140" />
                Are you hydrated?
              </li>
              <li className="flex items-center gap-3" data-id="element-1141">
                <div className="w-1.5 h-1.5 rounded-full bg-tealslate shrink-0" data-id="element-1142" />
                Are you hitting your protein targets?
              </li>
              <li className="flex items-center gap-3" data-id="element-1143">
                <div className="w-1.5 h-1.5 rounded-full bg-tealslate shrink-0" data-id="element-1144" />
                Are you lifting weights consistently?
              </li>
              <li className="flex items-center gap-3" data-id="element-1145">
                <div className="w-1.5 h-1.5 rounded-full bg-tealslate shrink-0" data-id="element-1146" />
                Are you under high stress?
              </li>
            </ul>
          </div>

          <div className="space-y-4 text-xs text-[#7A7A70] leading-[1.8]" data-id="element-1147">
            <p data-id="element-1148">
              <strong className="text-[#1F1F1F]" data-id="element-1149">Common causes:</strong>{' '}
              Metabolic adaptation, water retention, muscle gain offsetting fat
              loss, or inconsistent tracking.
            </p>
            <p data-id="element-1150">
              <strong className="text-[#1F1F1F]" data-id="element-1151">What to do:</strong> Review the
              fundamentals first. Consider tracking calories temporarily to
              ensure you are still in a deficit. Talk to your provider about a
              dose adjustment only after addressing your habits.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}